module.exports = __webpack_public_path__ + "media/images/companies/mufj_mucap_ja-8f23b3e9e97b801ffd319b314818ab08.png";